import React from "react";
import Page from "../Layout/Page/Page.component";

const NotFound = () => {
    return (
        <Page>
            <div className={'container pt-5 text-center'}>
                <h1>404</h1>
                <h1>Page not found!</h1>
            </div>
        </Page>
    )
};

export default NotFound;

